import { useContext } from 'react';

import { QSetContext } from './qset-provider';

function useQSet() {
  const context = useContext(QSetContext);

  if (!context) {
    throw new Error('useQSet must be used within a QSetProvider');
  }

  return context;
}

export { useQSet };
